import styled from 'styled-components';
import { rem } from 'polished';
import { LoginSaveCarTemplate } from './LoginSaveCarTemplate';

export const LoginSaveCarStyled = styled(LoginSaveCarTemplate)`
    text-align: center;
    font-size: ${rem('32px')};
    line-height: ${({ theme }) => theme.lineHeights.h2};
`;
